function waitForDeps(callback) {
  if (window.pako?.ungzip && window.jQuery && $.fn.DataTable) {
    callback();
  } else {
    setTimeout(() => waitForDeps(callback), 50);
  }
}


function waitForDataTables(callback) {
  if ($.fn.DataTable) {
    callback();
  } else {
    setTimeout(() => waitForDataTables(callback), 50);
  }
}

 const handlize = (str) =>
  str
    .toLowerCase()
    .trim()
    .replace(/['"`]/g, '') // remove apostrophes & quotes
    .replace(/[^a-z0-9]+/g, '-') // replace spaces/punctuation with dash
    .replace(/^-+|-+$/g, ''); // trim leading/trailing dashes